<template>
  <div class="brand_main">
    <div class="othen_search">
      <!-- 品牌查询 -->
      <div class="news_source">
        <div class="item_title">品牌:</div>
        <el-select v-model="searchForm.brandValue" placeholder="请选择" clearable filterable>
          <el-option
            v-for="item in brandOption"
            :key="item.value"
            :label="item.ZHName"
            :value="item.id"
          >
          </el-option>
        </el-select>
      </div>
      <!-- 情感 -->
      <div class="news_source">
        <div class="item_title">情感:</div>
        <el-select v-model="searchForm.emotionValue" placeholder="请选择">
          <el-option
            v-for="item in emotionData"
            :key="item.value"
            :label="item.label"
            :value="item.value"
          >
          </el-option>
        </el-select>
      </div>
      <!-- 大洲 -->
      <div class="news_source">
        <div class="item_title">大洲:</div>
        <el-select v-model="searchForm.continentValue" placeholder="请选择" @change="handleContinent">
          <el-option
            v-for="item in continentData"
            :key="item.value"
            :label="item.label"
            :value="item.value"
          >
          </el-option>
        </el-select>
      </div>
      <!-- 国家查询 -->
      <div class="news_source">
        <div class="item_title">国家:</div>
        <el-select v-model="searchForm.countryValue" placeholder="请选择" filterable @change="handleCountry">
          <el-option
            v-for="item in countryData"
            :key="item.value"
            :label="item.label"
            :value="item.value"
          >
          </el-option>
        </el-select>
      </div>
      <!-- 媒体查询 -->
      <div class="news_source">
        <div class="item_title">媒体:</div>
        <el-select v-model="searchForm.mediaValue" placeholder="请选择" filterable>
          <el-option
            v-for="item in mediaData"
            :key="item.value"
            :label="item.label"
            :value="item.value"
          >
          </el-option>
        </el-select>
      </div>
      <div class="news_source date_search">
        <!-- 品牌，情感，大洲，国家，媒体，时间 -->
        <div class="item_title">时间:</div>
        <el-date-picker
          type="date"
          value-format="yyyy-MM-dd"
          :picker-options="pickerOptionsStart"
          placeholder="开始时间"
          v-model="searchForm.startDate"
        ></el-date-picker>
        <span class="to_txt">&nbsp;&nbsp;-&nbsp;&nbsp;</span>
        <el-date-picker
          type="date"
          value-format="yyyy-MM-dd"
          :picker-options="pickerOptionsEnd"
          placeholder="结束时间"
          v-model="searchForm.endDate"
        ></el-date-picker>
      </div>
      <div class="news_source search_btn">
        <div class="item_submit" @click="searchOnClick">搜索</div>
      </div>
    </div>
    <!-- 数据表格 -->
    <div class="table">
      <el-table :data="tableData" style="width: 100%">
        <el-table-column prop="companyNameZh" label="品牌" >
        </el-table-column>
        <el-table-column prop="emotionMap" label="情感统计" >
          <template slot-scope="scope">
            <i @click="handleClick(scope.row)">
              <span class="word-list" v-if="scope.row.emotionMap.emotionPositiveCount">正面 ({{scope.row.emotionMap.emotionPositiveCount}}，{{scope.row.emotionMap.emotionPositivePercent}})</span>
              <span class="word-list" v-if="scope.row.emotionMap.emotionNeutralCount">中性 ({{scope.row.emotionMap.emotionNeutralCount}}，{{scope.row.emotionMap.emotionNeutralPercent}})</span> 
              <span class="word-list" v-if="scope.row.emotionMap.emotionNegativeCount">负面 ({{scope.row.emotionMap.emotionNegativeCount}}，{{scope.row.emotionMap.emotionNegativePercent}})</span>
            </i>
          </template>
        </el-table-column>
        <el-table-column prop="siteCount" label="媒体数量">
          <template slot-scope="scope">
            <i @click="mediaClick(scope.row)">{{scope.row.siteCount}}</i>
          </template>
        </el-table-column>
      </el-table>
    </div>
  </div>
</template>

<script>
import {
  findCompanyByName,
  emotionList,
  continentList,
  countryList,
  mediaList,
  brandStatistics
} from "@/common/js/http/version3Api.js";
import AbstractList from "@/common/components/AbstractList"
export default {
  mixins: [AbstractList],
  data() {
    return {
      pickerOptionsStart: {
        disabledDate: (time) => {
          let endDateVal = this.searchForm.endDate;
          if (endDateVal) {
            return time.getTime() > new Date(endDateVal).getTime();
          }
        },
      },
      pickerOptionsEnd: {
        disabledDate: (time) => {
          let beginDateVal = this.searchForm.startDate;
          if (beginDateVal) {
            return time.getTime() < new Date(beginDateVal).getTime();
          }
        },
      },
      brandOption: [],
      emotionData: [],
      continentData: [],
      countryData: [],
      mediaData: [],
      tableData: [],
      searchForm: {
        brandValue: '',
        emotionValue:'',
        continentValue:'',
        countryValue:'',
        mediaValue:'',
        startDate:'',
        endDate:''
      },
      isContionent: false,
      isCountry: false
    };
  },
  created() {
    this.getBrandOption()
    this.getEmotionList()
    this.getContinentData()
  },
  methods: {
    // 品牌列
    getBrandOption() {
      findCompanyByName('').then(res => {
        this.brandOption = res.result
        // console.log(res.result, '品牌列')
      })
    },
    // 情感列
    getEmotionList() {
      emotionList().then(res => {
        this.emotionData = res.result
        // console.log(this.emotionData, '情感列')
      })
    },
    // 大洲列
    getContinentData() {
      continentList().then(res => {
        this.continentData = res.result
      })
    },
    // 洲选择
    handleContinent() {
      if(this.searchForm.continentValue === '') {
        this.countryData = []
        this.mediaData = []
        this.searchForm.countryValue = ""
        this.searchForm.mediaValue = ""
      }else {
        this.searchForm.countryValue = ""
        this.searchForm.mediaValue = ""
        this.getCountryData(this.searchForm.continentValue)
      }
    },
    getCountryData(region) {
      countryList({region: region}).then(res => {
        this.countryData = res.result
      })
    },
    // 国家选择
    handleCountry() {
      this.searchForm.mediaValue = ""
      this.getMediaData(this.searchForm.countryValue)
    },
    getMediaData(country) {
      mediaList({country: country}).then(res => {
        this.mediaData = res.result
      })
    },
    //列表展示
    async fetchData() {
      if( this.searchForm.startDate == null || this.searchForm.startDate == 'Invalid date') this.searchForm.startDate = "";
      if(this.searchForm.endDate == null || this.searchForm.endDate ==  'Invalid date') this.searchForm.endDate = "";
      const form = {
        companyId: this.searchForm.brandValue,
        emotion: this.searchForm.emotionValue,
        region: this.searchForm.continentValue,
        country: this.searchForm.countryValue,
        site: this.searchForm.mediaValue,
        endTime: this.searchForm.endDate,
        startTime: this.searchForm.startDate
      }
      const res = await brandStatistics(form)
      if (res.code === 200) {
        this.tableData = res.result
      }
    },
    handleClick(row) {
      this.$router.push({
        name: 'FeelingDetail',
        query: {
          isTopShow: true,
          companyId: row.companyId,
          emotion: this.searchForm.emotionValue,
          region: this.searchForm.continentValue,
          country: this.searchForm.countryValue,
          site:this.searchForm.mediaValue,
          startTime: this.searchForm.startDate,
          endTime: this.searchForm.endDate
        }
      })
    },
    mediaClick(row) {
      this.$router.push({
        name: 'MediaDetail',
        query: {
          isTopShow: false,
          companyId: row.companyId,
          emotion: this.searchForm.emotionValue,
          region: this.searchForm.continentValue,
          country: this.searchForm.countryValue,
          site:this.searchForm.mediaValue,
          startTime: this.searchForm.startDate,
          endTime: this.searchForm.endDate
        }
      })
    }
  },
  watch: {
    "searchForm.continentValue"(value) {
      // 从详情页回到列表，监听大洲的值，只监听一次
      // 因为下拉框被初始化，无法驱动change事件
      // isContionent就是控制哪一次的，洲有值，就需要去查询国家下拉框的数据，所以调用了getCountryData方法
      if(value && !this.isContionent) {
        this.getCountryData(value)
        this.isContionent = true
      }
    },
    "searchForm.countryValue"(value) {
      if(value && !this.isCountry) {
        this.getMediaData(value)
        this.isCountry = true
      }
    }
  },
};
</script>

<style scoped>
.search {
  width: 20%;
  margin-top: 5px;
}

.search >>> .el-input-group__append .el-icon-search {
  font-size: 20px;
  font-weight: bold;
}

.search >>> .el-input-group__append {
  border: 0;
  background: transparent;
}

.search >>> .el-input__inner {
  border: 0;
  background: transparent;
}

.search >>> .input_style {
  border-radius: 40px;
  background: #f2f3f4;
  border: 1px solid #e2e3e4;
}

.othen_search {
  margin: 5px 0 0;
}

.othen_search {
  display: flex;
  flex-wrap: wrap;
}
.othen_search .news_source {
  padding: 10px 5px;
}
.to_txt {
  font-size: 14px;
  color: #4e5671;
}

.date_search {
  margin-bottom: 10px;
}

.othen_search .item_submit {
  cursor: pointer;
  width: 74px;
  height: 32px;
  line-height: 32px;
  text-align: center;
  font-size: 14px;
  color:#fff;
  background-color: #0078ff;
  border-radius: 2px;
}

.date_search >>> .el-input {
  width: 120px;
}

.date_search >>> .el-input__inner,
.date_search >>> .el-input__icon {
  height: 32px;
  line-height: 32px;
}

.item_title {
  display: inline-block;
  font-size: 14px;
  color: #4e5671;
  font-family: RCB;
  margin-right: 10px;
}

.news_source >>> .news_input {
  display: inline-block;
  width: 270px;
}

.news_source >>> .el-input__inner,
.news_source >>> .el-input__icon {
  height: 32px;
  line-height: 32px;
}

.data_list >>> .el-pagination {
  margin: 0 auto;
  text-align: center;
}
.news_source >>> .el-select > .el-input {
  width: 150px !important;
}
.date_search >>> .el-date-editor.el-input,
.el-date-editor.el-input__inner {
  width: 150px !important;
}
.date_search >>> .el-input--suffix .el-input__inner {
  padding-right: 20px !important;
}
.text_one_line {
  white-space: nowrap;
  text-overflow: ellipsis;
  overflow: hidden;
  word-break: break-all;
}

.text_two_line {
  text-overflow: -o-ellipsis-lastline;
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  line-clamp: 2;
  -webkit-box-orient: vertical;
}

.table {
  padding: 10px 0;
  margin-top: 10px;
}

.table >>> .el-table .el-table__header th {
  background: #f7f8fa;
  font-size: 14px;
  color: #6c757d;
}
.table>>> .el-table__header-wrapper {
  height: auto !important;
}
.word-list {
  display: block;
}
.news_source >>> .el-input .el-input__inner {
  color: #606266 !important;
}
</style>
